import type { SitesFilters } from "@landtechnologies/search-layer-contracts";
import { useMemo } from "react";
import { siteFiltersMapStore } from "react-migration/domains/sites/pipeline/filters/SiteFiltersStore/siteFiltersMapStore";
import { isDefined } from "react-migration/lib/util/isDefined";
import { mapStore } from "src/js/stores/map/store";
import { siteStore } from "src/js/stores/site/store";
import { useSnapshot } from "valtio/react";

export function useClusteredViewportSiteFilters(): SitesFilters {
  const { selectedProjectId } = useSnapshot(siteStore);
  const controlPanelFilters = useSnapshot(siteFiltersMapStore);
  const { settings: otherFilters } = useSnapshot(mapStore);

  return useMemo(
    () => ({
      stages: controlPanelFilters.stageIds,
      workspaces: [selectedProjectId].filter(isDefined),
      searchText: controlPanelFilters.searchString,
      assignees: controlPanelFilters.assignees,
      siteLabels: controlPanelFilters.siteLabels,
      localAuthorities: controlPanelFilters.localAuthorities,
      showHiddenSites: otherFilters.showHiddenSites,
      showSharedSites: otherFilters.showSharedSites,
    }),
    [selectedProjectId, controlPanelFilters, otherFilters]
  );
}
